<div class="flex flex-col container w-full">
    <nz-form-label nzFor="key">{{ to.label }}</nz-form-label>
    <user-select width="100%" (onUserChanged)="onClick($event)" [formControl]="formControl" [formlyAttributes]="field" [disabled]="to.disabled"
      ngDefaultControl [users]="to.options$ ? (to.options$ | async) : to.options" [pageSize]=10 [selectedUserId]="selectedUserId"></user-select>
</div>
